// extracted by mini-css-extract-plugin
module.exports = {"DoubleLine2":"_3IdHJ","doubleLine2":"_3IdHJ","top":"_1UWqv","bottom":"_3cugV","tile":"_2wpKr"};